import { ApiService, apiServiceInstance, AxiosFetchSiteDataResponse, FetchTicketDataResponse } from './ApiService';
import { GameInfo } from '../../common-types/GameInfo.type';
import { Game } from '../../common-types/GlobalExperienceState.type';

class ExperienceService {
  private apiServiceInstance: ApiService;

  public constructor () {
    this.apiServiceInstance = apiServiceInstance;
  }

  public getSiteInformations (siteKey: string): Promise<AxiosFetchSiteDataResponse> {
    return this.apiServiceInstance.fetchSiteData(siteKey);
  }

  private static sortGameFunction (game1: GameInfo, game2: GameInfo, ticketCode: string | null): number {
    // @TODO there is no ticketCode anymore from XPN, so no sort to do here.
    if (ticketCode !== null) {
      if (game1.code === ticketCode) {
        return -1;
      }
      if (game2.code === ticketCode) {
        return 1;
      }
    }
    if (game1.isGamePlayable && !game2.isGamePlayable) {
      return -1;
    }
    if (!game1.isGamePlayable && game2.isGamePlayable) {
      return 1;
    }
    return game1.priority - game2.priority;
  }

  public async getGamesInformations (
    cartUid: string,
    customerUid: string,
    siteKey: string,
    ticketCode: string | null
  ): Promise<{ games: Game[], firstGameData: Game }> {
    const { games } = await this.apiServiceInstance
      .fetchGamesList(cartUid, customerUid, siteKey);
    const sortedGameV2 = games
      .filter((game) => game.isGameV2)
      .sort((game1, game2) => ExperienceService.sortGameFunction(game1, game2, ticketCode));
    const gamesData = await Promise.all(sortedGameV2.map((game: GameInfo) => apiServiceInstance.fetchTicketData(game.code, siteKey, customerUid)
      .then((response: FetchTicketDataResponse): Game => {
        return {
          campaign: response.campaign,
          gameConfiguration: response.config.screens,
          isGamePlayable: game.isGamePlayable,
          thumbnailUrl: game.thumbnailGameImage,
          ticket: response.ticket,
        };
      })));
    const onlyPlayableGames = gamesData.filter((game) => game.isGamePlayable);
    return { firstGameData: onlyPlayableGames.length > 0
      ? onlyPlayableGames[0]
      : gamesData[0],
    games: onlyPlayableGames };
  }
}

export const experienceServiceInstance = new ExperienceService();
